import { render, staticRenderFns } from "./ModalDxHistoryNotes.vue?vue&type=template&id=42defb28&scoped=true"
import script from "./ModalDxHistoryNotes.vue?vue&type=script&lang=js"
export * from "./ModalDxHistoryNotes.vue?vue&type=script&lang=js"
import style0 from "./ModalDxHistoryNotes.vue?vue&type=style&index=0&id=42defb28&prod&lang=scss"
import style1 from "./ModalDxHistoryNotes.vue?vue&type=style&index=1&id=42defb28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42defb28",
  null
  
)

export default component.exports